import { type Tiers, TiersListe } from '@mairistem/comptabilite';
import * as React from 'react';
import { useHistory } from 'react-router';

const TiersListeContainer = () => {
	const history = useHistory();

	const handleSelectTiers = async (data: Tiers): Promise<Tiers> => {
		history.push(`/tiers/${data.identifiant}`);
		return data;
	};

	return <TiersListe onSelect={handleSelectTiers} />;
};

export default TiersListeContainer;
